import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Seo from '@/components/Seo';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Menu from '@/components/Menu';
import { useMobileDetect } from '@/utils/hooks/';

import { Container, Main } from './styles';

const Layout = ({ children, uri }) => {
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const isMobile = useMobileDetect();

  useEffect(() => { setIsOpenMenu(false); }, [uri]);

  useEffect(() => {
    if (!isOpenMenu || isMobile || typeof window === 'undefined' || !window.document.documentElement.scrollTop) return;

    window.scroll(0, 0);
  }, [isMobile, isOpenMenu]);

  return (
    <Container>
      <Seo uri={uri} />
      <Header isOpenMenu={isOpenMenu} toggleMenu={setIsOpenMenu} uri={uri} />
      <Menu isOpenMenu={isOpenMenu} toggleMenu={setIsOpenMenu} uri={uri} />
      <Main isOpenMenu={isOpenMenu}>
        {isOpenMenu || children}
      </Main>
      <Footer />
    </Container>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  uri: PropTypes.string.isRequired,
};

export default Layout;
